import { AsyncPipe, NgClass } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

import { EcmMaterialModule } from '@ecm/material';
import { EcmRouterModule, Link } from '@ecm/router';

import { ButtonViewModel } from '../../../../business/model/home/button.view-model';
import { ForbiddenViewModel } from '../../../../business/model/home/forbidden/forbidden.view-model';
import { UrlService } from '../../../../services/url.service';

@Component({
    selector: 'default-button-component',
    templateUrl: 'default-button.component.html',
    standalone: true,
    imports: [NgClass, EcmMaterialModule, AsyncPipe, EcmRouterModule],
})
export class DefaultButtonComponent implements OnChanges {
    @Input()
    public viewModel: ForbiddenViewModel;
    @Output()
    public readonly clickPrimaryButtonLink = new EventEmitter<ButtonViewModel>();
    @Output()
    public readonly clickSecondaryButtonLink = new EventEmitter<ButtonViewModel>();

    public constructor(private readonly urlService: UrlService) {}

    public isDisabledEclairPrimaryButtonLink: boolean;
    public isDisabledEclairSecondaryButtonLink: boolean;

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    public ngOnChanges(_changes: SimpleChanges): void {
        if (this.viewModel) {
            this.isDisabledEclairPrimaryButtonLink = this.getEclairStatus(this.viewModel.primaryButton?.link);
            this.isDisabledEclairSecondaryButtonLink = this.getEclairStatus(this.viewModel.secondaryButton?.link);
        }
    }

    private getEclairStatus(link: Link): boolean {
        let result = null;
        if (link) {
            result = this.urlService.isDisabledEclairLink(link);
        }
        return result;
    }

    public doClickPrimaryButtonLink() {
        this.clickPrimaryButtonLink.emit(this.viewModel.primaryButton);
    }
    public doClickSecondaryButtonLink() {
        this.clickSecondaryButtonLink.emit(this.viewModel.secondaryButton);
    }
}
